(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lux-series70-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lux-series70')) {
  customElements.define('lux-series70', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-spacing-config]').textContent);
      this.select = this.querySelector('[data-configuration]');
      this.select.addEventListener('change', () => this.update());
      this.update();
    }
    escape(value) {
      return String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }
    update() {
      const c = this.config.options[Number(this.select.value)];
      const l = Object.fromEntries(Object.entries(this.config.labels).map(([k,v]) => [k,this.escape(v)]));
      const measurement = (label,value) => `<div class="lw70-measurement"><span>${label}</span><strong>≥ ${value} <small>${l.unit}</small></strong></div>`;
      this.querySelector('[data-measurements]').innerHTML = measurement(l.wall,c.wall) + (c.gap ? measurement(l.gap,c.gap) : '');
      const x = c.gap ? 245 : 340;
      const patternId = `${this.id}-hatch`;
      const track = cx => `<path d="M${cx-39} 139 h23 v-45 h32 v45 h23 v-8 h-15 v-45 h-48 v45 h-15z" fill="#faf9f5" stroke="#263d32" stroke-width="2"/>`;
      const dim = (a,b,label) => `<path d="M${a} 155v62M${b} 155v62M${a} 203H${b}" stroke="#94764f" fill="none"/><path d="M${a-5} 210l10-14M${b-5} 210l10-14" stroke="#94764f"/><text x="${(a+b)/2}" y="192" text-anchor="middle" fill="#665239" font-size="17">≥ ${label} ${l.unit}</text>`;
      const svg = this.querySelector('[data-spacing-diagram]');
      svg.removeAttribute('aria-labelledby');
      svg.setAttribute('aria-label', `${this.config.labels.wall}: ≥ ${c.wall} ${this.config.labels.unit}${c.gap ? `; ${this.config.labels.gap}: ≥ ${c.gap} ${this.config.labels.unit}` : ''}`);
      svg.innerHTML = `<defs><pattern id="${patternId}" width="12" height="12" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="12" stroke="#c8cec2" stroke-width="1"/></pattern></defs><rect x="46" y="38" width="25" height="190" fill="url(#${patternId})"/><path d="M71 35V232" stroke="#263d32" stroke-width="2"/><text x="44" y="25" fill="#657169" font-size="11">${l.wallLabel}</text><rect x="72" y="63" width="496" height="68" fill="url(#${patternId})" stroke="#bac2b5"/><text x="556" y="49" text-anchor="end" fill="#657169" font-size="11">${l.ceiling}</text>${track(x)}${c.gap ? track(465) : ''}${dim(71,x,c.wall)}${c.gap ? dim(x,465,c.gap) : ''}<text x="${x}" y="250" text-anchor="middle" fill="#263d32" font-size="12">${this.escape(c.first)}</text>${c.gap ? `<text x="465" y="250" text-anchor="middle" fill="#263d32" font-size="12">${this.escape(c.second)}</text>` : ''}`;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
